export default "__VITE_ASSET__ggZ$3B4Z__"